define('app-CarouselLogoComponent/main',['./settings', 'text!../libs/owlCarousel/owl.carousel.min.css', 'text!../libs/owlCarousel/owl.theme.default.min.css', 'owlCarousel'],
    function (settings, styles, style2) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Gallery Widgets found.  app-CarouselGalleryComponent will not be available.');
                    return;
                }

                container.first()
                    .append('<style>' + styles + style2 + '</style>');

                container.find(".owl-carousel").each(function () {
                    $(this).owlCarousel({
                        nav: true,
                        dots: false,
                        responsive: {
                            0: {
                                items: 1
                            },
                            768: {
                                items: 2
                            },
                            992: {
                                items: 3
                            },
                            1200: {
                                items: 4
                            }
                        }
                    })
                    $('.item', this).css('visibility','visible')
                });
                


                window.loadedModules('app-CarouselGalleryComponent');
            }
        }
    }
);
